/*
    @providesModule GradientButtons
    
*/

// @no-reflective-bind-babel

import React, {PropsWithChildren} from 'react';

import LinearGradient from 'react-native-linear-gradient';

import {ButtonProps, StyleSheet, TouchableOpacity, View} from 'react-native';

import SkillzImage from 'SkillzImage';

interface PlayGradientButtonProps extends Partial<ButtonProps> {
  colors: string[];
  style?: Object;
}

export function PlayGradientButton(props: PropsWithChildren<PlayGradientButtonProps>) {
  return <RoundGradientButton {...props} source={'btn_play_match_select_skz.png'} />;
}

export function PlusGradientButton(props: Object): React.ReactNode {
  return <RoundGradientButton {...props} source={'btn_plus_match_select_skz.png'} />;
}

export function RoundGradientButton(props: Object): React.ReactNode {
  const radius = StyleSheet.flatten(props.style).height / 2;
  const imagePadding = 4;
  const buttonSize = (radius - imagePadding) * 2;
  const {...otherProps} = props;

  const imageStyle = {
    position: 'absolute',
    top: -imagePadding,
    left: -imagePadding,
    right: -imagePadding,
    bottom: -imagePadding,
    height: radius * 2,
    width: radius * 2,
  };

  const containerStyle = {
    backgroundColor: 'transparent',
    height: radius * 2,
    width: radius * 2,
    borderRadius: radius,
  };

  const gradientStyle = {
    borderRadius: radius - imagePadding,
    width: buttonSize,
    height: buttonSize,
  };

  return (
    <View {...otherProps} pointerEvents={'none'} style={containerStyle}>
      <TouchableOpacity activeOpacity={0.0} onPress={props.onPress}>
        <View>
          <LinearGradient
            pointerEvents={'none'}
            style={[gradientStyle, styles.gradientStyleConsts]}
            colors={props.colors}
          ></LinearGradient>
          <SkillzImage
            pointerEvents={'none'}
            resizeMode='contain'
            source={props.source}
            style={[imageStyle, StyleSheet.absoluteFill]}
          />
        </View>
      </TouchableOpacity>
      <View style={styles.childrenContainer}>{props.children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  childrenContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },

  gradientStyleConsts: {
    borderWidth: 0,
    margin: 4,
  },
});
